/**
 * Load CSS, add a style element to the head of the current document.
 * @param {string} cssString
 */
export const addStyle = function (cssString) {
  var style = document.createElement("style")
  style.appendChild(document.createTextNode(cssString));
  document.head.appendChild(style)
}
